import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

import { cn } from '../../../lib/utils';
import { announce } from '../../ui/live-announcer';

/** Copy-to-clipboard icon button that briefly confirms the copy with a check + pop animation. */
export function CreditCopyButton({ value, label }: { value: string; label: string }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        void navigator.clipboard?.writeText(value);
        setCopied(true);
        announce('Copied');
        window.setTimeout(() => setCopied(false), 1200);
    };

    return (
        <button
            type="button"
            onClick={handleCopy}
            title={label}
            aria-label={label}
            className={cn(
                '-m-1.5 shrink-0 rounded p-1.5 transition-transform duration-150 active:scale-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                copied ? 'scale-110 text-emerald-600' : 'text-neutral-400 hover:text-neutral-700',
            )}
        >
            {copied ? (
                <Check className="size-3.5" aria-hidden />
            ) : (
                <Copy className="size-3.5" aria-hidden />
            )}
        </button>
    );
}
